export default __webpack_public_path__ + "static/media/dashboard-exam.2ab197bc.svg";